<!-- Custom NgbDropdown -->
<div
	class="custom-dropdown-block"
	ngbDropdown
	#dropdownRef="ngbDropdown"
	#customDropdownElement
	[container]="container"
	[display]="display"
	autoClose="outside"
	(openChange)="onDropdownOpenChange($event)"
	(ngScroll)="closeOnScroll ? dropdownRef.close() : null"
>
	<!-- Button holds the selected value -->
	<button
		*ngIf="selectedOption"
		type="button"
		[attr.id]="elementId || id"
		class="form-control custom-dropdown-toggle"
		[ngClass]="toggleClass"
		ngbDropdownToggle
		[disabled]="isDisabled"
		(blur)="onTouched()"
	>
		<!-- Selected value with assets -->
		<ng-container
			*ngIf="!customTemplate; else ngContentTemplate"
			[ngTemplateOutlet]="contentTemplate"
			[ngTemplateOutletContext]="{ option: selectedOption, showOnlyText: onlyText }"
		></ng-container>

		<!-- Dynamic content from parent component -->
		<ng-template #ngContentTemplate>
			<ng-content></ng-content>
		</ng-template>

		<ng-fa-icon
			class="custom-dropdown-chevron"
			icon="chevron-down"
		></ng-fa-icon>
	</button>

	<!-- Dropdown menu -->
	<!-- eslint-disable-next-line @angular-eslint/template/no-inline-styles -->
	<div
		ngbDropdownMenu
		#dropdownMenu
		[ngClass]="['ng-custom-dropdown-menu', dropdownClass]"
		[attr.aria-labelledby]="elementId || id"
		[style.width.px]="matchToggleWidth ? customDropdownElement?.offsetWidth : null"
		[style.--custom-dropdown-min-width.px]="matchToggleWidth ? null : customDropdownElement?.offsetWidth"
	>
		<!-- Menu options  -->
		<ng-container *ngFor="let option of options; trackBy: trackOptionByValue">
			<button
				*ngIf="!option.hidden"
				type="button"
				ngbDropdownItem
				class="ng-custom-dropdown-option"
				[class.active]="value === option.value"
				[attr.aria-selected]="value === option.value"
				(click)="selectOption(option!)"
				[disabled]="option?.disabled || false"
			>
				<!-- Dropdown option template -->
				<ng-container
					[ngTemplateOutlet]="contentTemplate"
					[ngTemplateOutletContext]="{ option: option, showOnlyText: false }"
				></ng-container>
			</button>
		</ng-container>
	</div>
</div>

<!-- Dynamic template -->
<ng-template
	let-option="option"
	let-showOnlyText="showOnlyText"
	#contentTemplate
>
	<span
		class="asset-holder"
		*ngIf="!showOnlyText && option && (option.icon || option.img)"
	>
		<!-- FA icon -->
		<span
			*ngIf="option.icon"
			class="icon-block lh-1"
			[class.active]="value === option.value!"
		>
			<!-- eslint-disable-next-line @angular-eslint/template/no-inline-styles -->
			<ng-fa-icon
				[icon]="option.icon!.name"
				[iconStyle]="option.icon!.style"
			></ng-fa-icon>
		</span>

		<!-- Image -->
		<img
			width="25"
			height="25"
			class="custom-dropdown-image rounded-2"
			*ngIf="option.img"
			[src]="option.img"
			[alt]="option.label"
		/>
	</span>

	<!-- Option name -->
	<span
		class="custom-dropdown-label"
		[class.ms-2]="!showOnlyText && (option?.icon || option?.img)"
	>
		{{ option?.label }}
	</span>
</ng-template>
